export default "__VITE_ASSET__x$tG2Zpq__"